var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-template"},_vm._l((_vm.templates),function(temp,index){return _c('div',{key:index},[_c(temp.component,{tag:"component",attrs:{"data":temp.data}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }